import { Dispatch } from "react"
import { Action, Reducer } from "redux"
import StatusCode from "../util/StatusCode";
import InstanceClient from "../services/InstanceClient";
import store from "./store";
import { CoreObjectLogs } from '../models/CoreObjectLogs';
import { RequestState } from "../models/RequestState";


enum ObjectLogType {
    GET_OBJECT_LOGS = 'GET_OBJECT_LOGS',
};

export interface ObjectLogState {
    objectLogs: RequestState<CoreObjectLogs[]>
}

interface ObjectLog_Get extends Action<ObjectLogType>{
    type: ObjectLogType.GET_OBJECT_LOGS,
    objectLogs: RequestState<CoreObjectLogs[]>
}

type ObjectLogAction = ObjectLog_Get;


export const GetObjectLogs = (params: {objectId: string, objectSource: string, objectType: string}) => (dispatch: Dispatch<ObjectLog_Get> ) => {
    const storeKey = store.getState().objectLog.objectLogs?.key;
    const key = params.objectId + '-' + params.objectSource + '-' + params.objectType;
    if (key === storeKey) {
        return;
    }

    dispatch({
        type: ObjectLogType.GET_OBJECT_LOGS,
        objectLogs: { code: StatusCode.PENDING }
    })

    return InstanceClient.get<CoreObjectLogs[]>(`/api/core/module/moduleInstance/objectLog`, params)
        .then(res =>
            dispatch({
                type: ObjectLogType.GET_OBJECT_LOGS,
                objectLogs: { code: StatusCode.COMPLETE, data: res.data, key: key }
            })
        )
        .catch(err =>
            dispatch({
                type: ObjectLogType.GET_OBJECT_LOGS,
                objectLogs: { code: StatusCode.ERROR, error: err }
            })
        )
}

const initialState: ObjectLogState = {
    objectLogs: { code: StatusCode.NONE },
};

export const reducer: Reducer<ObjectLogState, ObjectLogAction> = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case ObjectLogType.GET_OBJECT_LOGS:
            return {
                ...state,
                objectLogs: action.objectLogs
            }
        default:
            return state;
    }
}
